<template>
	<div @click="$emit('click',$event)">
		SCHEDULER
	</div>
</template>

<script>
export default {
	name: "Scheduler",

	props: [],

	components: {},

	data: function () {
		return {}
	},

	mounted() {
	},

	beforeDestroy() {
	},

	methods: {},

	computed: {},

}
</script>

<style scoped lang="scss">

</style>